module.exports = __webpack_public_path__ + "static/media/Frame 1.fc7fb80f.jpg";